<div [formGroup]="form()" class="flex flex-col gap-3">
  <div class="flex flex-col">
    <span class="text-lg">{{ 'pages.campaignForm.sections.basics.customerLabel' | translate }}</span>
    <div class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.basics.customerDescription' | translate }}
    </div>
  </div>

  @if (loading()) {
    <ngx-skeleton-loader class="h-12" [theme]="{ width: '856px', height: '48px', 'border-radius': '100vw' }" />
  } @else {
    <div class="w-full">
      <mat-form-field class="w-full mat-form-field-with-icon">
        <mat-select
          panelClass="custom-select-panel"
          formControlName="customer"
          [hideSingleSelectionIndicator]="true"
          [placeholder]="'pages.campaignForm.sections.basics.selectOrAddCustomer' | translate"
        >
          <mat-select-trigger>
            <ng-container
              *ngTemplateOutlet="customOption; context: { $implicit: form().controls.customer.value, isTrigger: true }"
            />
          </mat-select-trigger>

          @if (canCreateCustomer()) {
            <mat-option class="mat-option-add-option" (click)="openCustomerCreateDialog()">
              <div class="flex items-center justify-center gap-2 w-full">
                <app-icon src="icons/plus.svg" class="w-5 h-5" />
                <span>{{ 'pages.campaignForm.sections.basics.addCustomer' | translate }}</span>
              </div>
            </mat-option>
          }

          <mat-option>
            <ngx-mat-select-search
              [formControl]="customerSearchControl"
              [placeholderLabel]="'pages.campaignForm.sections.basics.searchCustomer' | translate"
              [noEntriesFoundLabel]="'pages.campaignForm.sections.basics.noCustomersFound' | translate"
            >
              <app-icon ngxMatSelectSearchClear src="icons/close.svg" alt="close" class="w-4 h-4" />
            </ngx-mat-select-search>
          </mat-option>

          @for (customer of filteredCustomers(); track customer.id) {
            <mat-option [value]="customer">
              <ng-container *ngTemplateOutlet="customOption; context: { $implicit: customer, isTrigger: false }" />
            </mat-option>
          }
        </mat-select>
        <mat-error [control]="form().get('customer')" />
      </mat-form-field>
    </div>
  }
</div>

<ng-template #customOption let-item let-isTrigger="isTrigger">
  <div class="flex items-center gap-2 max-w-[300px]">
    <app-icon-badge
      [content]="item?.iconId"
      [fallbackText]="item?.name"
      [size]="32"
      [iconSize]="32"
      [fontSize]="16"
      [borderRadius]="100"
    />
    <div class="whitespace-nowrap overflow-hidden text-ellipsis flex-1 flex items-center gap-2">
      {{ item?.name }}

      @if (isTrigger && item) {
        <button mat-icon-button type="button" (click)="onCustomerClick(item, $event)">
          <app-icon src="icons/arrow-up-right.svg" alt="arrow up right" class="w-4 h-4" />
        </button>
      }
    </div>
  </div>
</ng-template>
